import { handleActions } from 'redux-actions'
import * as customVideoActions from '../actions'

export default handleActions(
  {
    [customVideoActions.setProcessing](state, action) {
      return action.payload
    },
    [customVideoActions.resetState](state, action) {
      return false
    },
  },
  false
)
